import * as signalR from "@microsoft/signalr";
import { AppSettings } from '../AppSettings';
import { TokenRefresher } from "./TokenRefreshener";

export class UseHub {
    static hubConnection: signalR.HubConnection | null = null;

    static checkConnectionState(): boolean {
        return UseHub.hubConnection?.state === signalR.HubConnectionState.Connected;
    }

    static connect(): void {
        if (UseHub.hubConnection) {
            return;
        }

        UseHub.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${AppSettings.baseLocation}chat`, {
                accessTokenFactory: () => {
                    const token = localStorage.getItem('token');
                    return token ? JSON.parse(token) : "";
                },
                transport: signalR.HttpTransportType.LongPolling
            })
            .withAutomaticReconnect()
            .build();

        UseHub.hubConnection.start()
            .then(() => {
                console.log('Подключение установлено');
            })
            .catch(err => {
                console.error('Ошибка подключения к SignalR Hub: ', err);
                TokenRefresher.refresh().then(() => {
                    UseHub.connect();
                });
            });

        UseHub.hubConnection.onreconnecting((error) => {
            console.log("Переподключение...", error);
        });
    }

    static reconnect(): void {
        console.log("reconnect");
        if (UseHub.hubConnection) {
            UseHub.hubConnection.stop();
        }

        UseHub.connect();

        setTimeout(() => {
            if (UseHub.hubConnection?.state !== signalR.HubConnectionState.Connected) {
                TokenRefresher.refresh().then(refreshResult => {
                    if (!refreshResult) {
                        console.log("Не удалось обновить токен, перезагрузка...");
                        localStorage.removeItem("token");
                        window.location.reload();
                    }
                });
            }
        }, 3000);
    }

    static addHandler(nameReceiver: string, receiverFunction: (...args: any[]) => void): void {
        if (!UseHub.hubConnection)
            return;
        UseHub.hubConnection.off(nameReceiver);
        UseHub.hubConnection.on(nameReceiver, receiverFunction);
    }

    static async invoke(nameFunction: string, obj: any): Promise<void> {
        if (!UseHub.hubConnection || UseHub.hubConnection.state !== signalR.HubConnectionState.Connected) {
            console.warn("Hub not connected, attempt reconnect");
            UseHub.reconnect();
            return;
        }

        try {
            await UseHub.hubConnection.invoke(nameFunction, obj);
        } catch (err) {
            console.error(`Error invoking ${nameFunction}:`, err);
        }
    }

    static disconnect(): void {
        if (UseHub.hubConnection) {
            UseHub.hubConnection.stop();
            UseHub.hubConnection = null;
        }
    }
}